let formateardateTo = function() {
	this.dateTo = new Date(
		(new Date(this.dateTo).toISOString() + "").slice(0, 10) + "T23:31:04.000Z"
		).toISOString();
};
export default formateardateTo;
